<div class="position-relative">
    <div class="dark-theme fixed-top border-bottom">
        <div class="container-fluid">
            <div class="row">
                <div class="d-none d-lg-block col-lg">
                    <a href="/" class="text-decoration-none text-white"><div class="subtitle text-uppercase py-3"><i>JOURNEY </i><span class="footnote">by
                            Equity
                            is Dynamic</span></div>
                    </a>
                </div>
                <div class="col-12 col-lg-auto">
                    <div class="row  py-1 py-lg-0 h-100 align-items-center justify-content-between">
                        <a [ngClass]="{'col-auto dashboard-header-icon journey-icon   ':true, 'active': module == 'journey'}"
                            href="/dashboard/journey"></a>
                        <a [ngClass]="{'col-auto dashboard-header-icon results-icon   ':true, 'active': module == 'results'}"
                            href="/dashboard/results"></a>
                        <a [ngClass]="{'col-auto dashboard-header-icon community-icon ':true, 'active': module == 'community'}"
                            href="/dashboard/community"></a>
                        <a [ngClass]="{'col-auto dashboard-header-icon profile-icon   ':true, 'active': module == 'profile'}"
                            href="/dashboard/profile"></a>
                        <div class="col-auto dashboard-header-icon settings-icon" data-toggle="collapse"
                            data-target="#three-dots-menu">
                        </div>
                        <div class="course-content three-dots-menu fixed-top dark-theme collapse" id="three-dots-menu">
                            <div class="border-top border-bottom">
                                <div class="container-fluid py-4">
                                    <div class="row">
                                        <div class="col-auto dashboard-header-icon settings-menu-icon"></div>
                                        <div class="col">
                                            <a class="text-btn" (click)="switchToModule('settings')"  data-toggle="collapse" data-target="#three-dots-menu">Settings and support</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="border-bottom">
                                <div class="container-fluid py-4">
                                    <div class="row">
                                        <div class="col-auto dashboard-header-icon logout-icon"></div>
                                        <div class="col">
                                            <a class="text-btn" (click)="logout()"  data-toggle="collapse" data-target="#three-dots-menu">Log out</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="dashboard-wrapper">
    <journey *ngIf="module == 'journey'"></journey>
    <results *ngIf="module == 'results'"></results>
    <community *ngIf="module == 'community' && !participant"></community>
    <profile *ngIf="module == 'community' && participant"></profile>
    <profile *ngIf="module == 'profile'  && !editProfile"></profile>
    <edit-profile *ngIf="module == 'profile' && editProfile"></edit-profile>
    <settings-and-support *ngIf="module == 'settings'"></settings-and-support>
</div>